import { Base } from "@studiometa/js-toolkit";
import { tns } from "tiny-slider";
class SliderMenu extends Base {
  mounted() {
    [this.current] = this.$refs.nav;
    this.slider = tns({
      container: this.$refs.container,
      center: false,
      controls: false,
      loop: false,
      autoplay: false,
      nav: false,
      items: 1,
      mouseDrag: false,
      autoplayButtonOutput: false,
      autoHeight: true
    });
  }
  onNavClick(e) {
    this.current.classList.remove("menu__tabs--current");
    this.current = e.currentTarget;
    const { position } = this.current.dataset;
    this.current.classList.add("menu__tabs--current");
    this.slider.goTo(position);
  }
}
SliderMenu.config = {
  name: "Slider",
  refs: ["container", "nav[]"]
};
export {
  SliderMenu as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
